/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Sync_Status_StartingInputs */



/**
* | output |
* | --- |
* | "Starting sync process... please wait." |
*
* @param {Event_Group_Sync_Status_StartingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_sync_status_starting = /** @type {((inputs?: Event_Group_Sync_Status_StartingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Sync_Status_StartingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Starting sync process... please wait.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Starting sync process... please wait.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Starting sync process... please wait.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Starting sync process... please wait.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Starting sync process... please wait.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Starting sync process... please wait.")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Starting sync process... please wait.")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Starting sync process... please wait.")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Starting sync process... please wait.")
	return /** @type {LocalizedString} */ ("Starting sync process... please wait.")
});